import {
  CustomAttributeType,
  CustomAttributeValue,
} from 'src/graphql/entities/custom-attributes/custom-attributes.types';
import { addressCustomAttributesConfig } from './address';
import { clientCustomAttributesConfig } from './client';
import { conversationCustomAttributesConfig } from './conversation';

export interface CustomAttributesSetFieldValueInput {
  entityId: string;
  key: string;
  type: CustomAttributeType;
  value: CustomAttributeValue;
  /** The definition's default, which is what a key the entity never stored renders as. */
  defaultValue?: unknown;
}

export interface CustomAttributesEntityConfig {
  useStoredAttributes: (entityId: string | undefined) => {
    customAttributes: string | null;
    loading: boolean;
  };
  useStoredAttributesByIds: (entityIds: readonly string[]) => {
    customAttributesById: ReadonlyMap<string, string | null>;
    loading: boolean;
  };
  useUpdateStoredAttributes: () => {
    setFieldValue: (input: CustomAttributesSetFieldValueInput) => Promise<void>;
  };
}

export const CUSTOM_ATTRIBUTES_CONFIG = {
  Conversation: conversationCustomAttributesConfig,
  Address: addressCustomAttributesConfig,
  Client: clientCustomAttributesConfig,
} as const satisfies Record<string, CustomAttributesEntityConfig>;

export type CustomAttributesEntity = keyof typeof CUSTOM_ATTRIBUTES_CONFIG;

export function getCustomAttributesConfig(
  entity: CustomAttributesEntity,
): CustomAttributesEntityConfig {
  return CUSTOM_ATTRIBUTES_CONFIG[entity];
}
